/**
 * Organizations Module Configuration
 *
 * Platform-level organization management.
 * Accessible only to super_admin users via Settings navigation.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const organizationsModule: AppModule = {
    id: 'organizations',

    navigation: {
        label: 'Organizations',
        icon: 'building-2',
        path: '/organizations',
        order: 95,
        moduleKey: 'settings.organizations',
        showInSidebar: false, // Accessed via Settings navigation group

        pages: [
            {
                label: 'All Organizations',
                path: '/organizations',
            },
            {
                label: 'Add Organization',
                path: '/organizations/create',
            },
        ],
    },

    routes,
}

export default organizationsModule
